export default {
  'monitor.title': '📊 COW Mining Monitor',
  'monitor.subtitle': 'Real-time mining activity statistics',
  'monitor.loading': 'Loading data...',
  'monitor.totalMiners': 'Total Miners',
  'monitor.activeMiners24h': 'Active (24h)',
  'monitor.walletSuffix': 'wallets',
  'monitor.totalCoweMined': 'Total COWe Mined',
  'monitor.coweSuffix': 'COW',
  'monitor.successRate': 'Success Rate',
};
